import { createFileRoute } from '@tanstack/react-router'
import { InspirationListContent } from '@/features/blog/components/InspirationListContent'
import { buildInspirationListHead } from '@/lib/seo/staticPages'

export const Route = createFileRoute('/_layout/inspirace/')({
  component: InspirationListPage,
  head: () => buildInspirationListHead(),
})

function InspirationListPage() {
  return <InspirationListContent />
}
